import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Navbar from "../../Navbar";
import { BasicDetails } from "../../../Reps/ConsignmentRequest/Detail/BasicDetails";
import { KitDetails } from "../../../Reps/ConsignmentRequest/Detail/KitDetailsTable";
import BookedByDetails from "../../../Reps/ConsignmentRequest/Detail/BookedByDetails";
import { consignmentService } from "../../../../../services/consignment.services";
import BookingTimeline from "../../../Reps/ConsignmentRequest/Detail/BookingTimeline";

const BookingReview = () => {
  const [bookingInfo, setBookingInfo] = useState({});
  const { id } = useParams();
  const history = useHistory();

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const response = await consignmentService.getConsignmentRequest({
          id,
        });
        setBookingInfo(response.data[0]);
      } catch (err) {
        console.error("Error fetching consignment details:", err);
      }
    };
    fetchInitialData();
  }, [id]);

  return (
    <div>
      <Navbar activePage="consignment-request" />
      <div className="container">
        <h1 className="date-scroll pt-4">
          <a onClick={() => history.goBack()}>
            <i className="fa fa-long-arrow-left smbtn"></i>{" "}
            <strong>Review Consignment Request</strong>
          </a>
        </h1>
        <div className="row pt-4 mobile_nocard">
          <div className="col-md-8">
            <BasicDetails bookingInfo={bookingInfo} />
            <KitDetails consignmentKits={bookingInfo.consignmentKits} />
          </div>
          <div className="col-md-4">
            <BookedByDetails bookingInfo={bookingInfo} />
            <BookingTimeline logData={bookingInfo.logData}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingReview;
